import { forwardRef, memo } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Prd2LineScrollBar from '@wconcept/wconcept-ui-renewal/components/atoms/Prd2LineScrollBar';
import * as S from './style';

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

interface IProps {
  title?: string;
  tagText?: string;
  productList?: React.ReactNode;
  colorType?: ColorType;
  onTouchStart?: (e: React.TouchEvent<HTMLDivElement>) => void;
  onTouchEnd?: (e: React.TouchEvent<HTMLDivElement>) => void;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
  scrollContainerRef?: React.RefObject<HTMLDivElement | null>;
}

const AdProductSection = forwardRef<HTMLDivElement, IProps>(
  (
    {
      title = '이런 상품 어떠세요?',
      tagText = '광고',
      productList,
      colorType = 'white',
      onTouchStart,
      onTouchEnd,
      onScroll,
      scrollContainerRef,
    },
    ref: React.Ref<HTMLDivElement>
  ) => {
    const isCustomColor = typeof colorType === 'object';
    const customColors = isCustomColor ? colorType : undefined;

    return (
      <S.AdProductSection
        className={`event-ad-product${!isCustomColor ? ` ${colorType}` : ''}`}
        $bgColor={customColors?.bgColor}
        $textColor={customColors?.textColor}
        ref={ref}
      >
        <S.Title>
          <Text
            className="content-title"
            weight={600}
            size={26}
            lineHeight="130%"
          >
            {title}
          </Text>
          <Text
            className="tag"
            weight={500}
            size={13}
            lineHeight="130%"
            color="#999"
          >
            {tagText}
          </Text>
        </S.Title>
        <Prd2LineScrollBar
          perView={2.93}
          rowGap={20}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
          onScroll={onScroll}
          ref={scrollContainerRef}
        >
          {productList}
        </Prd2LineScrollBar>
      </S.AdProductSection>
    );
  }
);

AdProductSection.displayName = 'AdProductSection';

export default memo(AdProductSection);

AdProductSection.displayName = 'AdProductSection';
